import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "icon", "iconScale", "height", "width", "children", "round"];
import React from 'react';
import styled from 'styled-components';
import { pxToRem } from 'utils/ui/units';
import { spacing } from 'styles/globals';
import { centerChildren } from 'styles/mixins';
import Icon from 'components/Icon';
import Spinner from 'components/Spinner';
import Heading from 'components/Heading';
import Text from 'components/Text';
import IconDisc from 'components/IconDisc';
var Wrapper = styled.div.withConfig({
  displayName: "Landmark__Wrapper",
  componentId: "sc-1wfri4b-0"
})(["", " max-width:", ";height:", ";flex:1 1 auto;margin:0 auto;padding:", ";"], centerChildren, function (p) {
  return pxToRem(p.width || 400);
}, function (p) {
  return p.height ? pxToRem(p.height) : '100%';
}, spacing.xs);
var Content = styled.div.withConfig({
  displayName: "Landmark__Content",
  componentId: "sc-1wfri4b-1"
})(["text-align:center;color:", ";& > * + *{margin-top:", ";}"], function (p) {
  return p.theme.text;
}, spacing.xs);
var Landmark = function Landmark(_ref) {
  var title = _ref.title,
    icon = _ref.icon,
    _ref$iconScale = _ref.iconScale,
    iconScale = _ref$iconScale === void 0 ? 2 : _ref$iconScale,
    height = _ref.height,
    width = _ref.width,
    children = _ref.children,
    round = _ref.round,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var iconEl = icon && (icon === 'spinner' ? /*#__PURE__*/React.createElement(Spinner, {
    dimmed: true
  }) : round ? /*#__PURE__*/React.createElement(IconDisc, {
    shady: true,
    name: icon,
    scale: iconScale
  }) : /*#__PURE__*/React.createElement(Icon, {
    dimmed: true,
    name: icon,
    scale: iconScale
  }));
  return /*#__PURE__*/React.createElement(Wrapper, _extends({}, otherProps, {
    width: width,
    height: height
  }), /*#__PURE__*/React.createElement(Content, null, iconEl, title && /*#__PURE__*/React.createElement(Heading, {
    as: "h2"
  }, title), children && /*#__PURE__*/React.createElement(Text, {
    as: "div"
  }, children)));
};
export default Landmark;